<!-- Header -->
<div class="modal-header">
  <h4 class="modal-title pull-left">Set Reminder</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span>
  </div>
</div>

<!-- Body -->
<div class="modal-body" id="sidenote-reminder">
  <form #reminderForm="ngForm">
    <div>
      <label class="rbv-label">Date</label>
      <input class="form-control" bsDatepicker placeholder="Pick Date"
        [(ngModel)]="date" [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', showWeekNumbers: false}"
        [minDate]="today" name="reminderDate" required/>
    </div>

    <div class="mt-3">
      <label class="rbv-label">Time</label>
      <timepicker name="reminderTime" required [(ngModel)]="time"></timepicker>
    </div>
  </form>
</div>

<!-- Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-rbv" [disabled]="!reminderForm.valid" (click)="setReminder()">Save</button>
</div>
